<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useOrganizerFeeDisplay } from '@/composables/useOrganizerFeeDisplay'

const { t } = useI18n()
const { registrationFeeParams } = useOrganizerFeeDisplay()

const open = ref<number | null>(null)

function toggle(index: number): void {
  open.value = open.value === index ? null : index
}

const questions = [1, 2, 3, 4, 5] as const

// Only the "what does it cost" answer (a1) embeds the configured platform
// fee - the rest render without interpolation params.
function answerParams(index: number): Record<string, string> {
  return index === 1 ? registrationFeeParams.value : {}
}
</script>

<template>
  <section class="bg-white py-24">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <p class="text-emerald-600 font-semibold text-sm uppercase tracking-widest">
          {{ t('organizers_lp.faq.label') }}
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('organizers_lp.faq.heading') }}
        </h2>
      </div>

      <div class="space-y-3">
        <div
          v-for="n in questions"
          :key="n"
          class="border border-slate-200 rounded-xl overflow-hidden"
        >
          <button
            type="button"
            class="w-full text-left px-6 py-4 flex items-center justify-between gap-4 hover:bg-slate-50 transition-colors"
            :aria-expanded="open === n"
            @click="toggle(n)"
          >
            <span class="font-semibold text-slate-900">{{ t(`organizers_lp.faq.q${n}`) }}</span>
            <span
              class="flex-shrink-0 text-slate-400 transition-transform duration-200"
              :class="open === n ? 'rotate-180' : ''"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
              </svg>
            </span>
          </button>
          <div
            v-if="open === n"
            class="px-6 pb-5 text-slate-600 leading-relaxed"
          >
            {{ t(`organizers_lp.faq.a${n}`, answerParams(n)) }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
